import { ReviewStatus } from "@redotech/redo-review-db-schema/review";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";

export const updateReview = {
  name: "updateReview" as const,
  input: z.object({
    _id: z.string(),
    teamId: z.string(),
    status: z.optional(createEnum(ReviewStatus)),
    verifiedPurchase: z.optional(z.boolean()),
    shopifyProductId: z.string().optional(),
    shopifyVariantId: z.string().nullish(),
    reply: z
      .object({ text: z.string(), sendEmail: z.boolean().optional() })
      .optional(),
  }),
  output: z.object({
    success: z.boolean(),
    replyAdded: z.boolean(),
    emailSent: z.boolean(),
    emailError: z.string().nullable(),
  }),
};
